import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default ({ filter, page, size, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, [])}` : '';
  const searchConfigOperatorVoice = `searchConfigOperatorVoice(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchConfigOperatorVoice} {
        id
        operatorId
        index
        tariff
        effectiveDate
        direction
        trafficType
      }
    }
  `;
};
